module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_unten_1.ad5f786c.jpg";